module.exports = __webpack_public_path__ + "static/img/icon.1e6ac14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_5/icon.jpg
// module id = JgtV
// module chunks = 0